<template>
	<div class="storage-info-body">
		<ul class="store-setting-header">
			<span>
				<i class="el-icon-back" @click="goBack"></i>
			</span>
			<li>出入库信息</li>
		</ul>
		<div class="goods-info-box">
			<div class="basis-info-body">
				<el-radio-group v-model="stocktype" size="small" style="margin-bottom: 20px;" @change="stockChange" :disabled="stockid!==''">
					<el-radio-button :label="0">入库</el-radio-button>
					<el-radio-button :label="1">出库</el-radio-button>
				</el-radio-group>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="form-box">
					<div class="info-box">
						<el-form-item label="类型：" ref="category" class="category-box">
							<el-select v-model="ruleForm.stock" :disabled="stockid!==''" class='short-input' size="small" placeholder="请选择类型" clearable filterable>
								<template v-for="(item) in stockList">
									<el-option
										:value="item.id"
										:label="item.name"
										:key="item.id"/>
								</template>
							</el-select>
							<el-select v-model="ruleForm.isGift" :disabled="stockid!==''" class='short-input' size="small" @change="giftChange">
								<el-option :value="0" label="非赠品"></el-option>
								<el-option :value="1" label="赠品"></el-option>
							</el-select>
							<el-button type='text' size="mini" style="margin-left:10px" v-if="!stockid" @click="showManage(0)">添加</el-button>
						</el-form-item>
						<el-form-item label="日期：">
							<!-- <span v-show="!editDate">{{storageDate}}</span> -->
							<el-date-picker
								size="mini"
								class="date-picker want-arrival-date long-input"
								:clearable="false"
								:editable="false"
								:disabled="stockid!==''"
								v-model="storageDate"
								type="datetime"
								placeholder="选择日期时间"
								format="yyyy-MM-dd HH:mm"
								value-format="yyyy-MM-dd HH:mm"
							/>
							<!-- <img class="item-img" src="~/images/icon/edit.png" alt="" @click="editWantDate"> -->
						</el-form-item>
						<el-form-item label="销售门店：" style="display:block" class="textarea-box">
							{{shopName}}
						</el-form-item>
						<el-form-item label="对方：" ref="category" class="category-box">
							<el-select v-model="ruleForm.otherside" :disabled="stockid!==''" class='long-input' size="small" placeholder="请选择对方名称" clearable filterable>
								<template v-for="(item) in otherList">
									<el-option
										:value="item.id"
										:label="item.name"
										:key="item.id"/>
								</template>
							</el-select>
							<el-button type='text' size="mini" style="margin-left:10px" v-if="!stockid" @click="showManage(1)">添加</el-button>
						</el-form-item>
						<el-form-item label="商品：" class="require-box">
							<el-select v-model="ruleForm.product" :disabled="stockid!==''" class='long-input info-select' ref="productRef" size="small" placeholder="请输入商品名称" filterable remote :remote-method="getProduct">
								<template v-for="(item) in productList">
									<el-option
										:value="item.uniqueId"
										:label="item.showName"
										:key="item.uniqueId"/>
								</template>
							</el-select>
						</el-form-item>
						<el-form-item label="金额：" class="require-box">
							<el-input v-model="ruleForm.number" :disabled="stockid!==''" class="money-input" size="small" @input="numberInput" @blur="numberBlur" placeholder="请输入数量"></el-input> x
							<el-input v-model="ruleForm.price" class="money-input" size="small" @input="priceInput" @blur="priceBlur" :disabled="ruleForm.isGift === 1 || stockid!==''" placeholder="请输入单价"></el-input> 元 =
							<el-input v-model="ruleForm.money" class="money-input" size="small" @input="moneyInput" @blur="moneyBlur" :disabled="ruleForm.isGift === 1 || stockid!==''" placeholder="请输入金额"></el-input> 元
						</el-form-item>
						<!-- <el-form-item label="">
							<el-input v-model="ruleForm.number" disabled class="money-input" size="small" @input="numberInput" @blur="numberBlur" placeholder="请输入数量"></el-input> x
							<el-input v-model="ruleForm.price" class="money-input" size="small" @input="priceInput" @blur="priceBlur" disabled placeholder="请输入单价"></el-input> 元 =
							<el-input v-model="ruleForm.money" class="money-input" size="small" @input="moneyInput" @blur="moneyBlur" disabled placeholder="请输入金额"></el-input> 元
						</el-form-item> -->
						<el-form-item label=""><span style="color:red">选择启用辅助单位的商品时，实际入库数量与单价会以换算后的基础单位为准</span></el-form-item>
						<el-form-item label="备注：" style="display:block" class="textarea-box">
							<el-input class='long-input' type="textarea" resize="none" placeholder="请输入备注" v-model="ruleForm.memo" :rows='4' :maxlength='300'></el-input>
						</el-form-item>
						<el-form-item label="附件：">
							<div>
								<ImgUpload
									class="show-img"
									v-for="(item, index) in showSrc"
									:key="index"
									:imgSrc.sync="item.url"
									:extension.sync="item.extension"
									:imgId.sync="item.id"
									:location="index"
									@deletImg="deletImg"
									@uploadNewImg="uploadNewImg"
									@preview2="preview2"
									ref="showUpload"
								/>
								<ImgUpload2
									class="show-img"
									v-if="showSrc.length < 3"
									@uploadNewImg="uploadNewImg"
									ref="showUpload2"
								/>
							</div>
							<div style="clear:left">最多上传3个，支持5M以内，格式png/jpg/jpeg/zip/rar/doc/xls/pdf/ppt文件</div>
						</el-form-item>
					</div>
				</el-form>
			</div>
		</div>
		<div class="btn-box">
			<el-button class="btn" size='small' plain type="primary" @click="cancel">取消</el-button>
			<el-button class="btn" size='small' plain type="primary" @click="savePost">保存</el-button>
			<el-button class="btn" size='small' type="primary" v-if="!stockid" @click="savePost(1)">保存并新建</el-button>
		</div>
		<el-dialog :title="dialogTitle" class="dialog-title" :visible.sync="typeModal" width='600px' :close-on-click-modal="false">
			<div style="text-align: left;margin: 10px 0;">
				<el-button size='small' type="primary" style="" plain class='fx-big-btn' @click="addBarcode">新增</el-button>
			</div>
			<div class="bar-wrap">
				<div class="bar-box" v-for="(item, index) in newManageData" :key="item.id">
					<div class="bar-content">
						<el-input type="text" :placeholder="'最多输入' + (manageType === 0 ? 10 : 50) + '个字'" size='mini' :maxlength="manageType === 0 ? 10 : 50" v-model='item.value'></el-input>
					</div>
					<div class="bar-delete" @click="deleteNew(index)">删除</div>
				</div>
				<div v-for="(item, index) in manageData" :key="item.id">
					<div class="bar-box" v-if="item.id !== 0">
						<div class="bar-content">
							<div>{{item.name}}</div>
						</div>
						<div class="bar-delete" @click="deleteOld(item.id, index)">删除</div>
					</div>
				</div>
			</div>
			<div class="valet-foot">
				<el-button class="btn" plain type="primary" size='small' @click="closeManage">取消</el-button>
				<el-button class="btn" plain type="primary" size='small' @click="saveManage">保存</el-button>
			</div>
		</el-dialog>
		<el-dialog
			title="附件"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			class="dialog-title"
			width="700px">
			<div class="preview-box"><w-image :src="previewSrc" alt="" width="400" height="400"></w-image></div>
		</el-dialog>
	</div>
</template>

<script>
import ImgUpload from '@/components/editStorage/ImgUpload.vue'
import ImgUpload2 from '@/components/editStorage/ImgUpload2.vue'
export default {
	name: 'editStorage',
	components: {
		ImgUpload,
		ImgUpload2
	},
	data () {
		var category = (rule, value, callback) => {
			if (this.isTrue === true) {
				return callback(new Error('店铺分类不能为空'))
			} else {
				callback()
			}
		}
		return {
			stockid: '',
			stocktype: 0,
			actualtimeinventoryflag: false,
			matchbillcenterflag: false,
			typeModal: false,
			dialogVisible: false,
			storageDate: '',
			dialogTitle: '入库添加类型',
			newManageData: [],
			manageData: [],
			productId: '',
			isTrue: true,
			manageType: 0,
			stockList: [],
			otherList: [],
			productList: [],
			previewSrc: '',
			ruleForm: {
				stock: 1,
				otherside: '',
				product: '',
				number: '',
				price: '',
				money: '',
				memo: '',
				isGift: 0
			},
			rules: {
				goodsName: [
					{ required: true, message: '请输入1~50个字范围内的商品名称', trigger: 'blur' }
				],
				code: [
					{ required: true, message: '请输入1～15个英文数字范围内的商品编号', trigger: 'blur' }
				],
				category: [
					{ required: true, validator: category, trigger: 'blur' }
				],
				startRadio: [
					{ required: true, message: '', trigger: 'blur' }
				],
				privateRadio: [
					{ required: true, message: '', trigger: 'blur' }
				]
			},
			showSrc: [],
			editShowSrc: [],
			editDisable: true,
			bigcategoryview: 0,
			isAdd: false,
			shopName: ''
		}
	},
	created () {
		this.setDate(new Date())
		this.stockid = this.$route.query.id || ''
		this.shopName = window.localStorage.getItem('shopName')
		this.$fxEventBus.$emit('setMenu', '14-1')
		if (this.stockid) {
			this.getDetail()
		} else {
			this.getStocktype()
			this.getOtherside()
			this.getProduct('')
		}
		this.getAuthority('02_0001_0000_00')
	},
	methods: {
		getOtherside () {
			let data = {
				stockType: this.stocktype,
				searchCustomer: true
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/stock/stockothers/find`,
				data: data
			}).then(res => {
				if (res.result) {
					this.otherList = res.data
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		getOtherside2 () {
			let data = {
				stockType: this.stocktype,
				searchCustomer: false
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/stock/stockothers/find`,
				data: data
			}).then(res => {
				if (res.result) {
					this.manageData = res.data
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		getProduct (query) {
			let data = {
				productName: query
				// page: 1,
				// size: 10000
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/stock/product/find`,
				data: data
			}).then(res => {
				if (res.result) {
					res.data.list.forEach(item => {
						item.showName = item.productName + ' 【' + item.productCode + '】' + ' 【' + item.productAttrplanName + '】' + ' 【' + item.productAttrplanCode + '】' + (item.unitName ? ' 【' + item.unitName + '】' : '') + (item.barCode === null ? '' : ' 【' + item.barCode + '】')
					})
					this.productList = res.data.list
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		getStocktype () {
			let data = {
				stockType: this.stocktype,
				searchDefault: true
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/stock/stocktype/find`,
				data: data
			}).then(res => {
				if (res.result) {
					this.stockList = res.data
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		giftChange (e) {
			// console.log(e)
			if (e === 1) {
				this.ruleForm.price = '0.00'
				this.ruleForm.money = '0.00'
			}
		},
		stockChange (e) {
			this.getStocktype()
			this.getOtherside()
			this.ruleForm.stock = 1
			this.ruleForm.otherside = ''
		},
		numberInput () {
			this.ruleForm.number = this.ruleForm.number.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			if (+this.ruleForm.number >= 10000) {
				this.ruleForm.number = this.ruleForm.number.substring(0, 4)
			} else {
				this.ruleForm.number = this.ruleForm.number.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
			}
		},
		priceInput () {
			this.ruleForm.price = this.ruleForm.price.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			if (+this.ruleForm.price >= 1000000) {
				this.ruleForm.price = this.ruleForm.price.substring(0, 6)
			} else {
				this.ruleForm.price = this.ruleForm.price.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
			}
		},
		moneyInput () {
			this.ruleForm.money = this.ruleForm.money.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			// if (+this.ruleForm.money >= 1000000) {
			// 	this.ruleForm.money = this.ruleForm.money.substring(0, 6)
			// } else {
			// 	this.ruleForm.money = this.ruleForm.money.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
			// }
		},
		numberBlur () {
			if (this.ruleForm.price && this.ruleForm.number) {
				this.ruleForm.money = this.$fxUtils.toFixedSHW((+this.ruleForm.number * +this.ruleForm.price), 2)
			}
		},
		priceBlur () {
			if (this.ruleForm.price && this.ruleForm.number) {
				this.ruleForm.money = this.$fxUtils.toFixedSHW((+this.ruleForm.number * +this.ruleForm.price), 2)
			}
		},
		moneyBlur () {
			if (this.ruleForm.money && this.ruleForm.number) {
				this.ruleForm.price = this.$fxUtils.toFixedSHW((+this.ruleForm.money / +this.ruleForm.number), 2)
			}
		},
		uploadNewImg (oldUrl, index, id) {
			index = index === undefined ? this.showSrc.length : index
			let needUrl = `${this.$fxBaseApi.urlQIVShop}/upload/document/temp`
			var formData = new FormData()
			let extension
			if (oldUrl === '') {
				formData.append('extension', this.$refs.showUpload2.fileFiles.name.split('.')[1])
				formData.append('file', this.$refs.showUpload2.fileFiles)
				formData.append('name', this.$refs.showUpload2.fileFiles.name.replace(' ', ''))
				extension = this.$refs.showUpload2.fileFiles.name.split('.')[1]
			} else {
				formData.append('extension', this.$refs.showUpload[index].fileFiles.name.split('.')[1])
				formData.append('file', this.$refs.showUpload[index].fileFiles)
				formData.append('name', this.$refs.showUpload[index].fileFiles.name.replace(' ', ''))
				extension = this.$refs.showUpload[index].fileFiles.name.split('.')[1]
			}
			this.$store.dispatch('requestFilePost', {
				url: needUrl,
				data: formData
			}).then(res => {
				if (res.result) {
					this.$message.success('上传成功')
					let img = { id: id || '', url: res.data.url, extension: extension, fileName: res.data.filename }
					if (oldUrl === '') {
						this.showSrc.push(img)
					} else {
						this.showSrc.splice(index, 1, img)
					}
					this.editShowSrc[index] = img
				} else {
					this.$message.error(res.msg)
				}
			}).catch((error) => {
				this.$message.error(error.msg)
			})
		},
		deletImg (id, index, path) {
			index = +index
			let params = {
				id: id,
				url: path
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/stock/document/remove`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('删除成功')
					this.showSrc.splice(index, 1)
					this.editShowSrc.splice(index, 1)
				} else {
					this.$message.error(res.msg)
				}
			}).catch((error) => {
				this.$message.error(error.msg)
			})
		},
		preview2 (src) {
			// console.log(this.showSrc)
			// this.initialIndex2 = this.showSrc.findIndex(item => {
			// 	return +item.id === +seqnum
			// })
			// console.log(this.initialIndex2)
			// // this.initialIndex2 = index
			// this.sellVoucherImg = this.showSrc.filter(item => {
			// 	return item.url !== ''
			// })
			// console.log(this.sellVoucherImg)
			// let emptyArr = []
			// this.sellVoucherImg = emptyArr.concat(seqnum)
			// console.log(this.sellVoucherImg)
			this.previewSrc = src
			this.dialogVisible = true
		},
		// 新增
		addBarcode () {
			let add = { value: '' }
			this.newManageData.push(add)
		},
		showManage (num) {
			this.newManageData = []
			this.manageType = num
			switch (num) {
			case 0:
				this.dialogTitle = `${this.stocktype === 0 ? '入库' : '出库'}添加类型`
				this.manageData = this.stockList
				break
			case 1:
				this.dialogTitle = '添加对方'
				this.getOtherside2()
				break
			}
			this.typeModal = true
		},
		saveManage () {
			if (this.newManageData.length === 0) {
				this.$message.error('当前无新增项')
				return false
			}
			for (let i = 0; i < this.newManageData.length; i++) {
				if (!this.newManageData[i].value) {
					this.$message.error('新增名称不能为空')
					return false
				}
			}
			let arr = this.newManageData.map(e => {
				return {
					stockType: this.stocktype,
					name: e.value
				}
			})
			// let data = {
			// 	stockTypeDTOList: arr
			// }
			let url = this.manageType === 0 ? `${this.$fxBaseApi.urlQIVShop}/stock/stocktype/save` : `${this.$fxBaseApi.urlQIVShop}/stock/stockothers/save`
			this.$store.dispatch('requestPost', {
				url: url,
				data: arr
			}).then(res => {
				if (res.result) {
					if (this.manageType === 0) {
						this.getStocktype()
						this.ruleForm.stock = 1
					} else {
						this.getOtherside()
						this.ruleForm.otherside = ''
					}
					this.$message.success('保存成功')
					this.typeModal = false
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		closeManage () {
			this.typeModal = false
		},
		deleteNew (index) {
			this.newManageData.splice(index, 1)
		},
		deleteOld (id, index) {
			let data = {
				id: id
			}
			let url = this.manageType === 0 ? `${this.$fxBaseApi.urlQIVShop}/stock/stocktype/remove` : `${this.$fxBaseApi.urlQIVShop}/stock/stockothers/remove`
			this.$store.dispatch('requestPost', {
				url: url,
				data: data
			}).then(res => {
				if (res.result) {
					if (this.manageType === 0) {
						this.getStocktype()
						this.ruleForm.stock = 1
					} else {
						this.getOtherside()
						this.ruleForm.otherside = ''
					}
					this.manageData.splice(index, 1)
					this.$message.success('删除成功')
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		goBack () {
			if (this.ruleForm.product !== '' || this.ruleForm.number !== '' || this.ruleForm.price !== '' || this.ruleForm.money !== '') {
				this.$confirm('有内容未保存,确定要取消吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.$router.push('/main/storage')
				}).catch(() => {})
			} else {
				this.$router.push('/main/storage')
			}
		},
		setDate (date) {
			let y = date.getFullYear()
			let m = date.getMonth() + 1
			let d = date.getDate()
			let h = date.getHours()
			let min = date.getMinutes()
			m = m < 10 ? '0' + m : m
			d = d < 10 ? '0' + d : d
			h = h < 10 ? '0' + h : h
			min = min < 10 ? '0' + min : min
			this.storageDate = `${y}-${m}-${d} ${h}:${min}`
			// return `${y}-${m}-${d}`
		},
		// 是否开启小类
		checkSmallCategory () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
				}).then(res => {
					resolve(res)
				})
			})
		},
		getDetail () {
			let params = {
				id: this.stockid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/stock/detail`,
				data: params
			}).then(res => {
				if (res.result) {
					this.stocktype = res.data.stockType
					this.getStocktype()
					this.getOtherside()
					this.getProduct('')
					this.ruleForm.stock = res.data.stockTypeId === 0 ? '' : res.data.stockTypeId
					this.ruleForm.isGift = res.data.giftFlag ? 1 : 0
					this.storageDate = res.data.stockDate
					this.ruleForm.number = res.data.productQuantity
					this.ruleForm.price = res.data.productPrice
					this.ruleForm.money = res.data.totalMoney
					this.ruleForm.memo = res.data.memo
					this.ruleForm.product = res.data.uniqueId
					this.shopName = res.data.shopName
					this.ruleForm.otherside = res.data.stockOthersId === 0 ? '' : res.data.stockOthersId
					if (res.data.stockDocuments !== null) {
						res.data.stockDocuments.forEach(e => {
							e.url = 'https://fxscms.oss-cn-beijing.aliyuncs.com' + e.url
						})
						this.showSrc = res.data.stockDocuments
					}
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result) {
					// console.log(res)
					let a = res.data
					if (a.indexOf('02_0001_0001_00') > -1) {
						this.editDisable = true
					} else {
						if (window.sessionStorage.getItem('goodsAdd') === 'true') {
							this.editDisable = true
						} else {
							this.editDisable = false
						}
					}
				}
			})
		},
		saveInfo (type) {
			// this.$refs['ruleForm'].validate((valid) => {
			// 	if (!valid) {
			// 		this.$message.error('请完善商品属性信息！')
			// 		return false
			// 	} else {
			// 		let isNew = 0
			// 		if (type === 2) {
			// 			isNew = 1
			// 		}
			// 		if (this.productId === '' || this.productId === null) {
			// 			type = 1
			// 		}
			// this.savePost()
			// 	}
			// })
		},
		translateImgArr (func) {
			return new Promise((resolve, reject) => {
				let previewArr = this.showSrc.reduce((pre, cur, index) => {
					let curSrc = this.$refs.showUpload[index][func]()
					if (curSrc) {
						pre.push(curSrc)
					}
					return pre
				}, [])
				if (previewArr.length === 0) {
					reject(previewArr)
				} else {
					resolve(previewArr)
				}
			})
		},
		savePost (type) {
			if (!this.ruleForm.product) {
				this.$message.error('请选择商品！')
				return false
			}
			if (this.ruleForm.number === '' || +this.ruleForm.number < 0 || +this.ruleForm.number > 9999.99) {
				this.$message.error('请输入0~9999.99内的数字！')
				return false
			}
			if (this.ruleForm.price === '' || +this.ruleForm.price < 0 || +this.ruleForm.price > 999999.99) {
				this.$message.error('请输入0~999999.99内的单价！')
				return false
			}
			if (this.ruleForm.money === '' || +this.ruleForm.money < 0) {
				this.$message.error('请输入正确的金额！')
				return false
			}
			let stockType, stockOthers, stockProduct
			for (let i = 0; i < this.stockList.length; i++) {
				let item = this.stockList[i]
				if (this.ruleForm.stock === item.id) {
					stockType = item
					break
				}
			}
			let stockKong = {
				stockType: this.stocktype
			}
			let othersKong = {
				othersType: 2
			}
			for (let i = 0; i < this.otherList.length; i++) {
				let item = this.otherList[i]
				if (this.ruleForm.otherside === item.id) {
					stockOthers = item
					break
				}
			}
			for (let i = 0; i < this.productList.length; i++) {
				let item = this.productList[i]
				if (this.ruleForm.product === item.uniqueId) {
					stockProduct = item
					stockProduct.productQuantity = this.ruleForm.number
					stockProduct.productPrice = this.ruleForm.price
					stockProduct.totalMoney = this.ruleForm.money
					stockProduct.giftFlag = this.ruleForm.isGift
					break
				}
			}
			let params = {
				id: this.stockid,
				updateStockType: stockType || stockKong,
				updateStockOthers: stockOthers || othersKong,
				updateStockProduct: stockProduct,
				memo: this.ruleForm.memo,
				stockDate: this.storageDate,
				updateStockDocuments: this.editShowSrc,
				stockDocumentCount: this.showSrc.length
			}
			// console.log(params)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/stock/save`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					if (type === 1) {
						// this.$refs.productRef.focus()
						this.setDate(new Date())
						this.ruleForm.product = ''
						this.ruleForm.number = ''
						if (this.ruleForm.isGift === 0) {
							this.ruleForm.price = ''
							this.ruleForm.money = ''
						} else {
							this.ruleForm.price = '0.00'
							this.ruleForm.money = '0.00'
						}
						this.ruleForm.memo = ''
						this.showSrc = []
						this.editShowSrc = []
						this.getProduct()
					} else {
						this.$router.push('/main/storage')
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		cancel () {
			if (this.ruleForm.product !== '' || this.ruleForm.number !== '' || this.ruleForm.price !== '' || this.ruleForm.money !== '') {
				this.$confirm('有内容未保存,确定要取消吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.$router.push('/main/storage')
				}).catch(() => {})
			} else {
				this.$router.push('/main/storage')
			}
		}
	}
}
</script>
<style lang="stylus">
	.category-box .el-form-item__content {
		width: 540px
	}
	.textarea-box .el-form-item__content {
		width: 350px
	}
	.textarea-box textarea {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
	}
	.state-box .el-form-item__content {
		width: 220px
	}
	.require-box .el-form-item__label:before {
		content: '*';
		color: #F56C6C;
		margin-right: 4px;
	}
	.el-dialog__body {
		padding-top: 10px;
		padding-bottom: 10px;
	}
	.info-select {
		.el-icon-:before{
			content: "\e6e1";
		}
		.is-focus{
			.el-icon-{
				transform: rotateZ(0)
			}
		}
	}
</style>
<style lang="stylus" scoped>
.storage-info-body {
	display flex
	flex: 1
	height: calc(100% - 75px)
	flex-direction column
	/deep/.el-form-item.is-success .el-input__inner {
		border-color: #DCDFE6
	}
	.dialog-title {
		text-align: left
		.bar-wrap {
			max-height: 300px;
			overflow-y: auto;
			.bar-box {
				display: flex;
				align-items: center;
				padding-right: 20px;
				line-height: 20px;
				margin-bottom: 15px;
				.bar-content {
					flex: 1;
					padding: 0 20px
				}
				.bar-delete {
					margin-left: auto;
					flex-shrink: 0;
					text-decoration: underline;
					color: var(--fx-primary-color);
					cursor: pointer;
					font-size: 13px
				}
			}
		}
		.valet-foot {
			height :40px;
			margin-top: 10px;
			text-align: center
			position :relative
			.btn{
				width :120px;
				height :35px;
				margin: 0 30px
			}
			.tip-box{
				position :absolute;
				width:400px;
				bottom :8px;
				text-align :left;
				left :750px;
				color :#999999
			}
		}
	}
	.preview-box {
		width: 100%;
		text-align: center;
		margin: 10px 0;
		img {
			display: inline-block
		}
	}
	.store-setting-header {
		border-bottom: 1px solid #dce2fd;
		height:66px;
		line-height: 66px;
		font-size: 18px;
		box-sizing border-box
		span {
			float left
			display inline-block
			line-height 66px
			padding-right 20px
			i {
				border-radius 50%
				background: #9da6af;
				padding: 3px;
				cursor pointer
			}
			.el-icon-back:before {
				content: "\E6EA";
				color: #fff;
				font-weight: bold;
			}
		}
		li {
			margin-right 40px
			height: 100%
			box-sizing:border-box
			float left
			&.active {
				border-bottom: 3px solid var(--fx-primary-color);
				font-weight: bold
			}
		}
	}
	.item-img {
		display: inline-block;
		vertical-align: middle;
		padding-left: 13px;
		cursor: pointer
	}
	.unit-box{
		display: flex;
		height: 60px;
		align-items :center;
		padding-left: 20px;
		flex-direction :row;
	}
	.goods-info-box {
		overflow-y auto
		display flex
		flex 1
		flex-direction column
		padding-left: 18%;
		.basis-info-body {
			padding-top: 20px
			box-sizing border-box
			// border-bottom: 1px solid #dce2fd
			text-align left
			p {
				height 20px
				line-height 20px
				border-left 4px solid var(--fx-primary-color)
				padding-left 8px
				position relative
				color: #9E9C9D
				font-size 14px
				span {
					&:first-child {
						font-size 16px
						color: #2c3e50
					}
					&:nth-of-type(2) {
						margin: 0 30px;
					}
				}
				.el-button {
					position absolute
					margin-left 30px;
					top: -4px;
				}
			}
			.form-box {
				display flex
				flex-direction: column
				padding-top 10px
				.info-box {
					// display: flex
					width: 100%
					min-width: 1000px
					margin-bottom: 15px;
					.long-input {
						width: 400px
					}
					.short-input {
						width: 195px
						&:nth-of-type(1) {
							margin-right 10px
						}
					}
					.money-input {
						width: 115px
					}
				}
				.status {
					flex: 7
					.status-icon {
						display inline-block
						width: 108px
						height: 56px
					}
					.pass {
						background-image: url('~images/icon/pass.png')
					}
					.pending {
						background-image: url('~images/icon/pending.png')
					}
					.reject {
						background-image: url('~images/icon/reject.png')
					}
					.submit {
						background-image: url('~images/icon/submit.png')
					}
				}
			}
		}
		.show-img-body {
			// padding: 20px 0
			// min-height: 440px
			box-sizing border-box
			border-bottom: 1px solid #dce2fd
			text-align left
			display flex
			padding-bottom: 10px;
			.img-box {
				flex: 1
				p {
					height 20px
					font-size 16px
					line-height 20px
					border-left 4px solid var(--fx-primary-color)
					padding-left 8px
				}
				.img-container {
					max-width: 600px
				}
				.img-tips {
					padding: 20px 0 20px 12px
					color: #a7a7a7
				}
			}
		}
		.goods-status-box {
			text-align left
			p {
				height 20px
				font-size 16px
				line-height 20px
				border-left 4px solid var(--fx-primary-color)
				padding-left 8px
				margin 20px 0
			}
			span {
				color: red
				margin-right 6px
			}
		}
	}
	.btn-box {
		padding: 20px 0
		text-align center
		.btn {
			width :130px;
			height :35px;
			margin-left :20px;
		}
	}
}

</style>
